module.exports = __webpack_public_path__ + "static/headshot-c32100ace682eca1806581b176c12873.png";